import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Contact} from '../models/contact';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';
import * as action from '../actions/contact';
import * as listaction from '../actions/list';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-contact-editor',
  template: `<div class="row form-group justify-content-center">
    <div class="col-md-8">
      <div class="card">
        <div class="card-body">
          <contact-form [contact]="contact$ | async" 
                        [isUserProfile]="isUserProfile" 
                        [isNewContact]="isNewContact" 
                        [working]="working$ | async"
                        (save)="save($event)"></contact-form>
        </div>
      </div>
    </div>
  </div>
  `
})
export class ContactEditorPageComponent implements OnInit {

  public contact$: Observable<Contact>;
  public isUserProfile = false;
  public isNewContact = false;
  public working$: Observable<boolean>;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private store: Store<fromRoot.State>) {
    this.contact$ = this.store.select(fromRoot.getCurrentContact);
    this.working$ = this.store.select(fromRoot.getContactWorking);
  }

  save(c: Contact) {
    if (this.isUserProfile) {
      this.store.dispatch(new action.SaveUserProfileAction(c));
    } else {
      this.store.dispatch(new action.SaveContactAction(c));
    }

  }

  ngOnInit() {
    const currentUrl = this.router.url;
    if (currentUrl === '/userprofile') {
      this.isNewContact = false;
      this.isUserProfile = true;
      this.store.select(fromRoot.getAuthUsername)
        .subscribe(un => {
          this.store.dispatch(new action.GetUserProfileAction(un));
        });
    } else {
      this.route.params.subscribe(params => {
        if (+params['id']) {
          this.store.dispatch(new action.GetContactDetailsAction(+params['id']));
        } else {
          this.isNewContact = true;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/contact-editor.ts